import React, { Component, ErrorInfo, ReactNode } from 'react';

import ProductionErrorCard from './ProductionErrorCard';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorCode?: string;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(error: Error): State {
    // Generate a unique error code for support reference
    const errorCode = `ERR-${Date.now().toString(36).toUpperCase()}`;
    return { hasError: true, error, errorCode };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Log full technical details to console (for developers)
    console.error('🚨 ErrorBoundary caught an error:', error, errorInfo);
    console.error('Error Code:', this.state.errorCode);
    console.error('Component Stack:', errorInfo.componentStack);
    
    // TODO: Send to error tracking service (Sentry, LogRocket, etc.)
    // sendErrorToTrackingService(error, errorInfo, this.state.errorCode);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ProductionErrorCard
          onRetry={() => window.location.reload()}
          onGoHome={() => window.location.href = '/'}
          errorCode={this.state.errorCode}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
